<template>
  <div class="pa-1">
    <v-card v-if="isRegistered">
      <v-card-title>
        <h2>مرحبا!</h2>
      </v-card-title>
      <v-card-text>
        <div>{{ customerInfo.fullName }}</div>
      </v-card-text>
    </v-card>
    <v-card v-else max-width="320px" class="mx-auto">
      <v-img max-height="125" contain src="@/assets/logo.jpg"></v-img>
      <v-card-title>
        <h4>تحديد كلمة مرور جديدة</h4>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            v-model="password"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            label="كلمة السر الجديدة"
          />
          <v-text-field
            v-model="confirmPassword"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            prepend-icon="mdi-lock"
            :type="showPassword ? 'text' : 'password'"
            label="تأكيد كلمة السر الجديدة"
          />
        </v-form>
        <v-alert v-if="showError" type="error"> {{ errorMessage }} </v-alert>
      </v-card-text>
      <v-card-actions justify-center>
        <v-btn @click="confirmReset" :loading="isSending" color="success" block
          >حفظ كلمة المرور الجديدة</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-snackbar top color="#019891" v-model="snackbar" timeout="5000">
      تم تغيير كلمة المرور بنجاح. يمكنك استخدام كلمة المرور الجديدة.

      <template v-slot:action="{ attrs }">
        <v-btn color="white" icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ResetPassword",

  //********************** */
  props: {
    /*     toekn: {
      type: String,
      default: "",
    },
    userId: {
      type: String,
      default: "",
    }, */
  },

  //********************** */
  components: {},

  //********************** */
  data: () => ({
    showPassword: false,
    showError: false,
    password: "",
    confirmPassword: "",
    isSending: false,
    errorMessage: "",
    snackbar: false, 
  }), 

  //********************** */
  computed: {
    ...mapGetters("Account", {
      isLoggedIn: "isLoggedIn",
      isRegistered: "isRegistered",
      customerInfo: "customerInfo",
    }),
    isLogInInfoValid: function () {
      return this.password === this.confirmPassword && this.password !== "";
    },
    isTokenValid: function () {
      return this.token !== "" && this.userId !== "";
    },
  },

  //********************** */
  methods: {
    confirmReset: async function () {
      let token = this.$route.query.token;
      let userId = this.$route.query.userId;
      this.isSending = true;
      try {
        await this.$store.dispatch("Account/confirmResetPassword", {
          userId: userId,
          token: token,
          password: this.password,
        });
        this.snackbar = true;
      } catch (error) {
        this.showError = true;
        setTimeout(() => (this.showError = false), 3000);
        this.errorMessage = error;
        //alert(error);
      }
      this.isSending = false;
    },
  },

  //*********************** */
  async mounted() {},
};
</script>

<style>
</style>